module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/features/6-108d23cb8c25ab189f5625b326716ec5.svg";